import { getUrlParameter, removeUrlParameter } from './helper'
import { notify } from 'notiwind'
const default_name = window.vueAppConfig?.settings?.cookieName ?? 'ne_twork'
const cookieExpiryDays = window.vueAppConfig?.settings?.cookieExpiryDays ?? 90
export function cookie (name = false, value = false, expire = false) {
  if (!name) {
    name = default_name
  }

  const tokenParam = getUrlParameter('token')
  if (tokenParam) {
    // remove user token from url
    clearUserData()
    removeUrlParameter('token')
    setCookie(default_name, tokenParam, { 'max-age': 60 * 24 * 60 * 60 }) // 60 days in seconds

    // call api login with token
    const data = {
      session_id: tokenParam,
      brand_id: window.vueAppConfig.info.id
    }
    fetch(window.vueAppConfig.endpoint + '/api/v2/session/check', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        if (data.status && data.data) {
          setUserData(data.data)
          notify(
            {
              title: data.message,
              type: 'success',
              group: 'info'
            },
            5000
          )
          window.location.reload() // Reload the page to reflect the changes
        } else {
          notify(
            {
              text: data.message,
              type: 'error',
              group: 'error'
            },
            15000
          )
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
    return tokenParam
  }

  const affliateParam = getUrlParameter('vafh')
  if (affliateParam) {
    removeUrlParameter('vafh')
    const data = {
      affiliate_hash: affliateParam,
      session_id: cookie(),
      brand_id: window.vueAppConfig.info.id
    }
    fetch(window.vueAppConfig.endpoint + '/api/v2/session/check', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        if (data.status && data.data) {
          console.log('Check success:', data.data)
        } else {
          console.error('Check failed:', data.message)
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
    return tokenParam
  }

  let matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    )
  )
  let existingValue = matches ? decodeURIComponent(matches[1]) : null

  if (value !== false) {
    if (expire !== false) {
      expire = new Date(new Date().getTime() + expire * 60 * 1000)
    } else {
      expire = new Date(
        new Date().getTime() + cookieExpiryDays * 24 * 60 * 60 * 1000
      )
    }

    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}; expires=${expire.toUTCString()}; path=/`
    return value
  } else {
    if (existingValue === null) {
      let newValue = generateHash()
      expire = new Date(
        new Date().getTime() + cookieExpiryDays * 24 * 60 * 60 * 1000
      )
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
        newValue
      )}; expires=${expire.toUTCString()}; path=/`
      return newValue
    }
    return existingValue
  }
}
export function getCookieValue (name) {
  if (!name) {
    name = default_name
  }
  let matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    )
  )
  let existingValue = matches ? decodeURIComponent(matches[1]) : null
  return existingValue
}
export function deleteCookie (name) {
  document.cookie = encodeURIComponent(name) + '=; Max-Age=0; path=/;'
}

export function setCookie (name, value, options = {}) {
  options = {
    path: '/',
    ...options
  }

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString()
  } else if (options['max-age']) {
    options['max-age'] = `max-age=${options['max-age']}`
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value)
  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey
    let optionValue = options[optionKey]
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue
    }
  }

  document.cookie = updatedCookie
}

export function generateHash () {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  )
}

export function setUserData (user) {
  localStorage.setItem(default_name + '_user', JSON.stringify(user))
}

export function getUserData (probe = false) {
  if (!probe) {
    const user = localStorage.getItem(default_name + '_user')
    return user ? JSON.parse(user) : null
  }

  const data = {
    session_id: cookie(),
    brand_id: window.vueAppConfig.info.id
  }
  fetch(window.vueAppConfig.endpoint + '/api/v2/session/check', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .then(data => {
      if (data.status && data.data) {
        setUserData(data.data)
        return data.data
      } else {
        completelogout()
      }
    })
    .catch(error => {
      console.error('Error:', error)
    })
}

export function clearUserData () {
  // check if exist
  if (localStorage.getItem(default_name + '_user') === null) {
    return
  }
  localStorage.removeItem(default_name + '_user')
}

export function completelogout () {
  clearUserData()
  deleteCookie(default_name)
  const newToken = generateHash()
  setCookie(window.vueAppConfig?.cookieName ?? 'MT', newToken, {
    'max-age': 60 * 24 * 60 * 60
  })
  // redirect user to login page
  //window.location.href = '/' + getSystemPath('login')
}

export function logout () {
  const data = {
    session_id: cookie(),
    brand_id: window.vueAppConfig.info.id
  }
  fetch(window.vueAppConfig.endpoint + '/api/v2/session/logout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.json()
    })
    .then(data => {
      if (data.status) {
        completelogout()

        window.location.reload() // Reload the page to reflect the changes
      } else {
        console.error('Logout failed:', data.message)
      }
    })
    .catch(error => {
      console.error('Error:', error)
    })
}
